import { FC } from 'react';
import classnames from 'classnames';

export interface IFooterRangeCalculatorProps {
  minStep?: string;
  maxStep?: string;
  prefix?: string;
  prefixPosition?: 'first' | 'last';
  classFooterMinValue?: string;
  classFooterMaxValue?: string;
}

const FooterRangeCalculator: FC<IFooterRangeCalculatorProps> = ({
  minStep,
  maxStep,
  prefix,
  prefixPosition,
  classFooterMinValue,
  classFooterMaxValue
}) => {
  return (
    <>
      <span className={classnames('range__footer-prefix', classFooterMinValue)}>
        {prefixPosition === 'first' && prefix} {minStep} {prefixPosition !== 'first' && prefix}
      </span>
      <span className={classnames('range__footer-prefix', classFooterMaxValue)}>
         {prefixPosition === 'first' && prefix} {maxStep} {prefixPosition !== 'first' && prefix}
      </span>
    </>
  );
};

export default FooterRangeCalculator;
